import React, { useContext } from 'react';

const attemptsContext = React.createContext();
const attemptsUpdateContext = React.createContext();

export function useAttempts() {
   return useContext(attemptsContext);
}

export function useAttemptsUpdate() {
    return useContext(attemptsUpdateContext)
}

export function AttemptsProvider({ children }) {

    const [attempts, setAttempts] = React.useState(0);
    function setUserAttempts(_result) {
        console.log(_result);
        setAttempts(_result);
    }
    
    return (

        <attemptsContext.Provider value={attempts}>
            <attemptsUpdateContext.Provider value={setUserAttempts}>
                {children}
            </attemptsUpdateContext.Provider>
        </attemptsContext.Provider>

    )
}